import { Button, Switch } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useApplicationsTableState } from 'components/Dashboard/ApplicationsTable/ApplicationsTableState.context';
import styles from './ColumnToggles.module.css';

export const ColumnToggles = () => {
  const { table } = useApplicationsTableState();

  const resetColumnVisibility = () => {
    table.getAllColumns().forEach((column) => column.toggleVisibility(true));
  };

  return (
    <div className={styles.columnSettings}>
      <h3 className={styles.heading}>
        <Trans>Customise columns</Trans>
      </h3>
      <p className={styles.subHeading}>
        <Trans>
          Change what columns you want to display or drag to reorder the column.
        </Trans>
      </p>
      <div className={styles.columnList}>
        {table
          .getAllLeafColumns()
          .filter((column) => column.columnDef.enableHiding !== false)
          .map((column) => {
            const renderLabel = () =>
              typeof column.columnDef.header === 'function'
                ? column.id
                : column.columnDef.header;

            return (
              <div className={styles.item} key={column.id}>
                <span>{renderLabel()}</span>
                <Switch
                  data-testid={`display-toggle-${column.id}`}
                  checked={column.getIsVisible()}
                  onClick={column.getToggleVisibilityHandler()}
                />
              </div>
            );
          })}
      </div>
      <Button
        onClick={resetColumnVisibility}
        className={styles.displayAllButton}
        variant="secondary-alt"
      >
        <Trans>Reset columns to default</Trans>
      </Button>
    </div>
  );
};
